module.exports = __webpack_public_path__ + "img/65exp.e5544c4c.jpg";